export default "__VITE_ASSET__BNjHOd_i__"